export default __webpack_public_path__ + "static/media/hadoop-svgrepo-com.441cbdf1.svg";